<template>
  <transition>
    <div class="company_main">
      <!-- 公司介绍 -->

      <div class="aboutUs_company_content">
        <img src="../assets/pcImg/pc_info.png" alt width="100%" class="animate__animated animate__fadeInUp animate__delay-01s" />
        <!-- <p class="p_line animate__animated animate__fadeInUp">{{ $t("m.company.content1") }}</p> -->
        <!-- <br />
        <br />-->
        <!-- <p class="p_line animate__animated animate__fadeInUp animate__delay-02s">{{ $t("m.company.content2") }}</p> -->
        <p class="p_center animate__animated animate__fadeInUp animate__delay-01s">
          <img src="../assets/pcImg/aboutUs_img.png" alt class="img_about" />
        </p>
      </div>
      <!-- <div class="animate__animated animate__fadeInUp animate__delay-03s"> -->
      <div class="mb_map animate__animated animate__fadeInUp animate__delay-03s">
        <img src="../assets/pcImg/map.png" alt class="mapImg" />
        <div class="sz_point point point-flicker">
          <p class="point_name">{{ $t("m.company.sz") }}</p>
        </div>
        <div class="aboutUs_pointExplain">
          <div class="headquarters">
            <div class="headquarters_"></div>
            <p>{{ $t("m.company.head") }}</p>
          </div>
          <div class="issuing">
            <div class="issuing_"></div>
            <p>{{ $t("m.company.issuing") }}</p>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <!-- <div class="xg_point point point-flicker">
        <p class="point_name">{{$t('m.company.xg')}}</p>
      </div>
      <div class="tw_point point point-flicker">
        <p class="point_name">{{$t('m.company.tb')}}</p>
      </div>
      <div class="hg_point point point-flicker">
        <p class="point_name">{{$t('m.company.hg')}}</p>
      </div>
      <div class="dny_point point point-flicker">
        <p class="point_name">{{$t('m.company.dny')}}</p>
      </div>
      <div class="bm_point point point-flicker">
        <p class="point_name">{{$t('m.company.bm')}}</p>
      </div>-->
    </div>
  </transition>
</template>
<script>
export default {
  name: 'CompanyIntro',
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  beforeDestroy() {},
}
</script>
<style scope="this api replaced by slot-scope in 2.5.0+" lang="scss">
.mb_map {
  position: absolute;
  width: 12.9rem;
  left: 50%;
  margin-left: -6.45rem;
  top: 4.78rem;
}
.company_main {
  height: 14rem;
  margin-top: -1rem;
  background: url('../assets/pcImg/company/0bg.jpg') no-repeat;
  background-size: 100% 100%;
}
.aboutUs_company_title {
  width: 12rem;
  color: white;
  font-size: 0.36rem;
  position: absolute;
  top: 1rem;
  margin-left: -6rem;
  text-align: center;
  left: 50%;
  letter-spacing: 0px;
}
.aboutUs_company_title::after {
  content: '';
  display: block;
  margin-left: 5rem;
  margin-top: 0.1rem;
  width: 2rem;
  height: 2px;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) 10%,
    rgba(251, 140, 76, 0.3) 20%,
    rgba(251, 140, 76, 0.4) 30%,
    rgba(251, 140, 76, 0.5) 40%,
    rgba(251, 140, 76, 0.8) 50%,
    rgba(251, 140, 76, 0.5) 60%,
    rgba(251, 140, 76, 0.4) 70%,
    rgba(251, 140, 76, 0.3) 80%,
    rgba(0, 0, 0, 0) 90%,
    rgba(0, 0, 0, 0) 100%
  );
}
.aboutUs_company_content {
  position: absolute;
  width: 11.12rem;
  left: 50%;
  top: 1.56rem;
  margin-left: -5.56rem;
  font-family: PingFang-SC-Medium;
  font-size: 0.18rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.25rem;
  letter-spacing: 0px;
  color: #ffffff;
  .p_line {
    text-indent: 2em;
  }
  .p_center {
    width: 100%;
    text-align: center;
  }
  .img_about {
    width: 6.87rem;
    height: 0.78rem;
    margin: 0.5rem auto 0.65rem;
  }
}
.mapImg {
  position: absolute;
  width: 12.9rem;
  left: 50%;
  margin-left: -6.45rem;
  top: 0;
}
.sz_point {
  position: absolute;
  top: 2.94rem;
  left: 50%;
  margin-left: 3.8rem;
  color: white;
  font-size: 13px;
}
.tw_point {
  position: absolute;
  top: 5.65rem;
  left: 50%;
  margin-left: 4.4rem;
  color: white;
  font-size: 13px;
}
.hg_point {
  position: absolute;
  top: 5rem;
  left: 50%;
  margin-left: 4.64rem;
  color: white;
  font-size: 13px;
}
.xg_point {
  position: absolute;
  top: 5.6rem;
  left: 50%;
  margin-left: 4.1rem;
  color: white;
  font-size: 13px;
  p {
    margin-top: 0.16rem;
    margin-left: 0rem;
  }
}
.dny_point {
  position: absolute;
  top: 6.5rem;
  left: 50%;
  margin-left: 3.9rem;
  color: white;
  font-size: 13px;
}
.bm_point {
  position: absolute;
  top: 5rem;
  left: 50%;
  margin-left: -4.3rem;
  color: white;
  font-size: 13px;
}
.point_name {
  display: block;
  width: 0.6rem;
  margin-top: 0.05rem;
  margin-left: 0.2rem;
}
.aboutUs_pointExplain {
  position: absolute;
  width: 3rem;
  height: 1rem;
  top: 7.02rem;
  left: 50%;
  margin-left: -5.5rem;
  color: white;
  font-size: 16px;
  p {
    display: inline-block;
  }
  .headquarters,
  .issuing {
    margin-bottom: 0.1rem;
  }
  .headquarters_ {
    background-color: #00ffff;
  }
  .issuing_ {
    background-color: #f08200;
  }
  .headquarters_,
  .issuing_ {
    width: 0.2rem;
    height: 0.2rem;
    display: inline-block;
    vertical-align: bottom;
    margin-right: 0.1rem;
    border-radius: 0.2rem;
  }
}
.point {
  width: 0.14rem;
  height: 0.14rem;
  background-color: #00ffff;
  position: relative;
  border-radius: 50%;
}

/* 设置动画前颜色 */
.point-flicker:after {
  background-color: #00ffff69;
}

/* 设置动画后颜色 */
.point-flicker:before {
  background-color: #00ffff1e;
}
.sz_point.point {
  width: 0.14rem;
  height: 0.14rem;
  background-color: #00ffff;
  position: relative;
  border-radius: 50%;
}

// /* 设置动画前颜色 */
// .sz_point.point-flicker:after {
//   background-color: #f0840081;
// }

// /* 设置动画后颜色 */
// .sz_point.point-flicker:before {
//   background-color: #f0840044;
// }
/* 设置动画 */
.point-flicker:before,
.point-flicker:after {
  content: '';
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -0.2rem;
  margin-top: -0.2rem;
  border-radius: 50%;
  animation: warn 1.5s ease-out 0s infinite;
}

/* @keyframes 规则用于创建动画。在 @keyframes 中规定某项 CSS 样式，就能创建由当前样式逐渐改为新样式的动画效果。 */
@keyframes warn {
  0% {
    transform: scale(0.3);
    opacity: 1;
  }

  30% {
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>